import React from "react";
import { Reveal } from "@/components/Reveal";

// Simple, editorial legal page — GDPR-friendly baseline for a launching brand.
// Copy is intentionally minimal; expand once a legal counsel has finalized T&Cs.
const SECTIONS = [
    {
        title: "Publisher",
        body: (
            <>
                <p>Tony Rays — Simplicity is Freedom.</p>
                <p className="mt-2">Website: tonyrays.com</p>
                <p className="mt-2">
                    Contact:{" "}
                    <a
                        href="mailto:contact@tonyrays.com"
                        className="link-underline"
                        data-testid="legal-email"
                    >
                        contact@tonyrays.com
                    </a>
                </p>
            </>
        ),
    },
    {
        title: "Hosting",
        body: (
            <p>
                This website is hosted on Emergent Labs infrastructure —
                emergent.host. Server location: European Union / United States
                (multi-region CDN).
            </p>
        ),
    },
    {
        title: "Intellectual Property",
        body: (
            <p>
                All content on this website — logo, product photography, copy,
                visuals, and UI — is the exclusive property of Tony Rays. Any
                reproduction, adaptation, or distribution without prior written
                consent is strictly prohibited.
            </p>
        ),
    },
    {
        title: "Personal Data",
        body: (
            <>
                <p>
                    We collect only the data necessary to process your order:
                    name, email, shipping address, and payment information
                    (handled by Stripe — we never store card details).
                </p>
                <p className="mt-3">
                    You have the right to access, correct, or delete your data
                    at any time. To exercise these rights, contact us at
                    contact@tonyrays.com.
                </p>
            </>
        ),
    },
    {
        title: "Cookies",
        body: (
            <p>
                This website uses essential cookies for basic functionality
                (cart, session). No third-party tracking cookies are enabled
                without your consent.
            </p>
        ),
    },
    {
        title: "Payments & Shipping",
        body: (
            <p>
                Payments are processed securely by Stripe. Shipping and returns
                are governed by our terms — 30-day free return policy on all
                unopened boxes. For details, please contact us before placing
                a large order.
            </p>
        ),
    },
    {
        title: "Governing Law",
        body: (
            <p>
                These terms are governed by French law. Any dispute will be
                submitted to the competent courts of the seller's registered
                office.
            </p>
        ),
    },
];

export default function Legal() {
    return (
        <div data-testid="legal-page" className="pt-40 md:pt-48 pb-24">
            <section className="max-w-[900px] mx-auto px-5 sm:px-8">
                <Reveal>
                    <span className="eyebrow text-ink/50">Legal Mentions</span>
                </Reveal>
                <Reveal delay={0.05}>
                    <h1 className="mt-6 font-serif text-5xl md:text-7xl tracking-[-0.03em] leading-[0.95]">
                        The <span className="italic font-light">fine print.</span>
                    </h1>
                </Reveal>

                <div className="mt-16 space-y-14">
                    {SECTIONS.map((s, i) => (
                        <Reveal key={s.title} delay={0.05 + i * 0.03}>
                            <div>
                                <p className="eyebrow text-ink/45 mb-3">
                                    {String(i + 1).padStart(2, "0")}
                                </p>
                                <h2 className="font-serif text-2xl md:text-3xl tracking-[-0.02em] mb-4">
                                    {s.title}
                                </h2>
                                <div className="text-base text-ink/75 leading-relaxed">
                                    {s.body}
                                </div>
                            </div>
                        </Reveal>
                    ))}
                </div>
            </section>
        </div>
    );
}
